const data = [
  {
    alias: "watermark",
    title: "watermark web app",
    subtitle: "branding, web design & programming",
    date: "Spring 2021",
    tag: ["branding", "ux/ui design", "dev/programming", "vue"],
    imgDim: "rect",
    img: "https://davyjonesdesign.github.io/data-for-axios/assets/watermark/home.jpg",
    imgs: [
      {
        src: "https://davyjonesdesign.github.io/data-for-axios/assets/watermark/home.jpg",
        title: "Watermark Home Page",
        width: "40vw",
        dimension: "landscape",
      },
      {
        src: "https://davyjonesdesign.github.io/data-for-axios/assets/watermark/study.jpg",
        title: "Watermark Study Page",
        width: "40vw",
        dimension: "landscape",
      },
      {
        src: "https://davyjonesdesign.github.io/data-for-axios/assets/watermark/resources.jpg",
        title: "Watermark Resources Page",
        width: "40vw",
        dimension: "landscape",
      },
      {
        src: "https://davyjonesdesign.github.io/data-for-axios/assets/watermark/home-m.png",
        title: "Watermark Mobile Home Page",
        width: "40vw",
        dimension: "portrait",
      },
      {
        src: "https://davyjonesdesign.github.io/data-for-axios/assets/watermark/study-m.png",
        title: "Watermark Mobile Study Page",
        width: "40vw",
        dimension: "portrait",
      },
      {
        src: "https://davyjonesdesign.github.io/data-for-axios/assets/watermark/resource-m.png",
        title: "Watermark Mobile Resources Page",
        width: "40vw",
        dimension: "portrait",
      },
    ],
    links: [
      {
        link: "https://www.watermarkstudies.com/",
        linkDescription: "Watermark Website",
      },
    ],
    description: [
      "The Watermark Web App serves as an intuitive and engaging app to organize a large selection of bible studies. Input and research showed that Vue was the most viable framework for building this application. Deciding to target older generations, the focus shifted to enhancing accessibility and legibility based on user research. UI design patterns based on this research were developed to reflect a scholarly and calm aesthetic.",
      "I deployed the app with GitHub pages and shared it with friends and family. As I continue working on this on-going project, I plan to integrate this and future feedback in new versions.",
    ],
  },
  {
    alias: "airbnb",
    title: "airbnb web design",
    subtitle: "full brand and web redesign for senior women",
    date: "Fall 2020",
    tag: ["branding", "ux/ui design"],
    imgDim: "rect",
    img: "https://davyjonesdesign.github.io/data-for-axios/assets/airbnb/desktop-reserve.png",
    imgs: [
      {
        src: "https://davyjonesdesign.github.io/data-for-axios/assets/airbnb/desktop-reserve.png",
        title: "Airbnb — Desktop Reserve",
        width: "40vw",
        dimension: "landscape",
      },
      {
        src: "https://davyjonesdesign.github.io/data-for-axios/assets/airbnb/desktop-main.png",
        title: "Airbnb — Desktop Main",
        width: "40vw",
        dimension: "landscape",
      },
      {
        src: "https://davyjonesdesign.github.io/data-for-axios/assets/airbnb/desktop-map.png",
        title: "Airbnb — Desktop Map",
        width: "40vw",
        dimension: "landscape",
      },
      {
        src: "https://davyjonesdesign.github.io/data-for-axios/assets/airbnb/mobile-main.png",
        title: "Airbnb — Mobile Main",
        width: "15vw",
        dimension: "portrait",
      },
      {
        src: "https://davyjonesdesign.github.io/data-for-axios/assets/airbnb/mobile-experiences.png",
        title: "Airbnb — Mobile Experiences",
        width: "13vw",
        dimension: "portrait",
      },
      {
        src: "https://davyjonesdesign.github.io/data-for-axios/assets/airbnb/mobile-lists.png",
        title: "Airbnb — Mobile Lists",
        width: "13vw",
        dimension: "portrait",
      },
      {
        src: "https://davyjonesdesign.github.io/data-for-axios/assets/airbnb/mobile-reserve.png",
        title: "Airbnb — Mobile Reserve",
        width: "13vw",
        dimension: "portrait",
      },
    ],
    links: [
      {
        link: "https://www.figma.com/proto/bLww2BBvNUsjAAZbIOgu4w/airbnb-redesign?node-id=317%3A1591&scaling=scale-down&page-id=301%3A751&starting-point-node-id=317%3A1591&hide-ui=1",
        linkDescription: "Project Overview",
      },
      {
        link: "https://www.figma.com/proto/pP3gPoziHkUfTXNzMu8Cmr/6.3-updated-brand-style-guide_v3?node-id=2%3A3&scaling=scale-down&page-id=0%3A1&starting-point-node-id=2%3A3&hide-ui=1",
        linkDescription: "Brand Style Guide",
      },
      {
        link: "https://www.figma.com/proto/bLww2BBvNUsjAAZbIOgu4w/airbnb-redesign?node-id=317%3A1614&scaling=scale-down&page-id=0%3A1&starting-point-node-id=317%3A1614&hide-ui=1",
        linkDescription: "Figma Design System",
      },
      {
        link: "https://www.figma.com/proto/74IM7vTuezwu4BEJlcWk3L/12.3-desktop-prototype?node-id=1%3A19&scaling=scale-down&page-id=0%3A1&starting-point-node-id=1%3A19&hide-ui=1",
        linkDescription: "Desktop Prototype",
      },
      {
        link: "https://www.figma.com/proto/IcrbeoQpx5xN3oFAHnHQra/11.3-final-revisions-mobile?node-id=200%3A2525&scaling=contain&page-id=0%3A1&starting-point-node-id=200%3A2525&hide-ui=1",
        linkDescription: "Mobile Prototype",
      },
    ],
    description: [
      "I set out to enhance the Airbnb brand and website by changing the target audience to women in their sixties. After some research, I discovered that Airbnb targets millennials and ignores older generations.  I focused on three main areas to change — branding, accessibility, and functionality. Changes in these areas increases engagement within this new target audience.",
      "I developed a user persona and user flowchart which led to a mood board and a new brand style guide. I then started sketching the mobile and desktop layouts. Using Figma, I designed components and documented them into a design system. Afterwards, I designed and prototyped the mobile and desktop wireframes. After peer reviews and feedback,  these final prototypes were successful.",
    ],
  },
  {
    alias: "forward",
    title: "forward",
    subtitle: "full brand and web design for industrial marketing firm",
    date: "Spring 2020",
    tag: ["branding", "ux/ui design"],
    imgDim: "rect",
    img: "https://davyjonesdesign.github.io/data-for-axios/assets/fwd/fwd-home_thumb.jpg",
    imgs: [
      {
        src: "https://davyjonesdesign.github.io/data-for-axios/assets/fwd/fwd-home.jpg",
        title: "Forward — Home Page",
        width: "40vw",
        dimension: "landscape",
      },
      {
        src: "https://davyjonesdesign.github.io/data-for-axios/assets/fwd/fwd-about.jpg",
        title: "Forward — Contact Page",
        width: "40vw",
        dimension: "landscape",
      },
      {
        src: "https://davyjonesdesign.github.io/data-for-axios/assets/fwd/fwd-blog.jpg",
        title: "Forward — Blog Page",
        width: "40vw",
        dimension: "landscape",
      },
      {
        src: "https://davyjonesdesign.github.io/data-for-axios/assets/fwd/fwd-blog-single.jpg",
        title: "Forward — Blog Single Page",
        width: "40vw",
        dimension: "landscape",
      },
    ],
    description: [
      "While working for a industrial manufacturer, I was given an opportunity to create a brand and website design for our small creative agency. With industrial companies in mind, my team and I worked together to develop a brand and website that would succeed at gaining traction in this market. After countless reviews of my proposed logos and layouts, we finalized our name, logo and website design.",
    ],
  },
  {
    alias: "central-wire-industries",
    title: "central wire industries",
    subtitle: "branding and web design",
    date: "Summer 2020",
    tag: ["branding", "ux/ui design"],
    imgDim: "rect",
    img: "https://davyjonesdesign.github.io/data-for-axios/assets/cwi-web-mockups.jpg",
    imgs: [
      {
        src: "https://davyjonesdesign.github.io/data-for-axios/assets/cwi-web-mockups.jpg",
        title: "CWI Web Mockups",
        width: "40vw",
        dimension: "landscape",
      },
      {
        src: "https://davyjonesdesign.github.io/data-for-axios/assets/cwi-web.jpg",
        title: "CWI Home Page",
        width: "40vw",
        dimension: "landscape",
      },
    ],
    description: [
      "With the marketing team at Central Wire Industries, I designed a bold and industrial focused brand and website.",
    ],
  },
  {
    alias: "hums-whistles",
    title: "hums & whistles",
    subtitle: "digital instrument",
    date: "Spring 2021",
    tag: ["dev/programming"],
    imgDim: "rect",
    img: "https://davyjonesdesign.github.io/data-for-axios/assets/hums-whistles.jpg",
    imgs: [
      {
        src: "https://davyjonesdesign.github.io/data-for-axios/assets/hums-whistles.jpg",
        title: "Hums & Whistles",
        width: "40vw",
        dimension: "landscape",
      },
    ],
    links: [
      {
        link: "https://djones794.studio.mcad.edu/pftw-spring21/wk12/assignment/",
        linkDescription: "Hums & Whistles",
      },
    ],
    description: [
      "The intension behind this piece is an accessible and unique digital instrument. This instrument would have audial output and analogous visual expressions. I recorded some sounds and settled on a few of my wife’s hums and whistles.",
      "I then used the P5 library to load sounds and connected their levels to expanding rectangles. Colorful rectangles pop on top of the muted, gray background. By pressing the parallel keystrokes, the user can hear and see the results.",
    ],
  },
  {
    alias: "stem",
    title: "stem research group",
    subtitle: "logo and branding",
    date: "Summer 2020",
    imgDim: "rect",
    img: "https://davyjonesdesign.github.io/data-for-axios/assets/stem/stem-brand.jpg",
    tag: ["branding"],
    imgs: [
      {
        src: "https://davyjonesdesign.github.io/data-for-axios/assets/stem/stem-brand.jpg",
        title: "Stem Brand Logo",
        width: "40vw",
        dimension: "landscape",
      },
      {
        src: "https://davyjonesdesign.github.io/data-for-axios/assets/stem/stem__mockup--facebookpage.jpg",
        title: "Stem Facebook Mockup",
        width: "40vw",
        dimension: "landscape",
      },
      {
        src: "https://davyjonesdesign.github.io/data-for-axios/assets/stem/stem__mockup--linkedinpage.jpg",
        title: "Stem Linkedin Mockup",
        width: "40vw",
        dimension: "landscape",
      },
      {
        src: "https://davyjonesdesign.github.io/data-for-axios/assets/stem/stem__mockup--shirt.jpg",
        title: "Stem Shirt Mockup",
        width: "40vw",
        dimension: "landscape",
      },
      {
        src: "https://davyjonesdesign.github.io/data-for-axios/assets/stem/stem__mockup--snapback.jpg",
        title: "Stem Hat Mockup",
        width: "40vw",
        dimension: "landscape",
      },
    ],
    links: [
      {
        link: "https://www.figma.com/proto/EcIoejAw8NHmiB90THbhOy/Brand-Guidelines-Design-Book-Style-Guide-Free-Template-(Community)?node-id=210%3A15&scaling=contain&page-id=1%3A55&starting-point-node-id=210%3A15",
        linkDescription: "Stem Logo Guide",
      },
    ],
    description: [
      "In 2020, STEM Search Group, a recruiting company, asked me to design their logo. I met with their leadership team and gathered intel on their market and position. After more research, I sketched initial concepts for their review.",
      "I polished the ideas up using Illustrator and presented them to the team. We agreed on one that met the desired results the team was looking for. I then developed a more robust brand by providing social media graphics and mockups of this logo in use. Though they did not pursue a full style guide, I provided them a basic logo guide along with assets.",
    ],
  },
  {
    alias: "friendship-prod",
    title: "friendship productions",
    subtitle: "brandiing",
    date: "Spring 2020",
    tag: ["branding", "motion graphic"],
    imgDim: "rect",
    img: "https://davyjonesdesign.github.io/data-for-axios/assets/friendship-productions-main.jpg",
    imgs: [
      {
        src: "https://davyjonesdesign.github.io/data-for-axios/assets/friendship-production-vid.gif",
        title: "Friendship Productions Motion Graphic",
        dimension: "landscape",
      },
      {
        src: "https://davyjonesdesign.github.io/data-for-axios/assets/friendship-prod_color.png",
        title: "Friendship Productions Still Logo",
        dimension: "landscape",
      },
    ],
    description: [
      "Logo and logo animation for a video and media group focused on creating in-house videos for Friendship Baptist Church.",
    ],
  },
  {
    alias: "liberty-missions",
    title: "Liberty Missions Motion Video",
    subtitle: "motion graphic and video production",
    date: "Fall 2019",
    tag: ["video", "motion graphic"],
    imgDim: "rect",
    vid: "https://davyjonesdesign.github.io/data-for-axios/assets/missions-motion-graphic.mp4",
    vidPoster:
      "https://davyjonesdesign.github.io/data-for-axios/assets/missions-motion-graphic.jpg",
    imgs: [
      {
        src: "https://davyjonesdesign.github.io/data-for-axios/assets/missions-motion-graphic.gif",
        title: "Liberty Missions — Motion Graphic",
        width: "40vw",
        dimension: "landscape",
      },
      {
        src: "https://davyjonesdesign.github.io/data-for-axios/assets/missions-motion-graphic.jpg",
        title: "Liberty Missions — Motion Graphic",
        width: "40vw",
        dimension: "landscape",
      },
    ],
    description: ["Liberty Missions Graphic"],
  },
  {
    alias: "church-booklet",
    title: "church booklet",
    subtitle: "branding and web design",
    date: "Summer 2020",
    tag: ["branding", "digital illustration", "print"],
    imgDim: "rect",
    img: "https://davyjonesdesign.github.io/data-for-axios/assets/lbc-booklet.jpg",
    imgs: [
      {
        src: "https://davyjonesdesign.github.io/data-for-axios/assets/lbc-booklet.jpg",
        title: "LBC Booklet Mockup",
        width: "40vw",
        dimension: "landscape",
      },
    ],
    description: [
      "Infographic design, illustration, and booklet design for Liberty Bible Church in Chesterton, IN.",
    ],
  },
  {
    alias: "breakfast",
    title: "breakfast",
    subtitle: "digital illustration",
    date: "Spring 2022",
    tag: ["digital illustration", "typography"],
    img: "https://davyjonesdesign.github.io/data-for-axios/assets/breakfast/breakfast-square.png",
    imgDim: "square",
    imgs: [
      {
        src: "https://davyjonesdesign.github.io/data-for-axios/assets/breakfast/breakfast-mural-mockup.jpg",
        title: "Breakfast Mural Mockup",
        width: "40vw",
        dimension: "landscape",
      },
      {
        src: "https://davyjonesdesign.github.io/data-for-axios/assets/breakfast/breakfast-square.png",
        title: "Breakfast",
        width: "40vw",
        dimension: "square",
      },
    ],
    description: [
      "A recent assignment from the Typography course was to select a word and depict it on a mural wall in a way that emphasizes its meaning. I selected “breakfast” and replaced each letter with a hand-drawn breakfast item. I wanted it to feel fun, playful, and filling — as if you are being treated to a big breakfast buffet!",
    ],
  },
];

export default data;
